let hostname=window.location.hostname;
let hostNameNoWWW=hostname.replace('www.','');
let hostNameWithPort=hostNameNoWWW;

const portNumber = window.location.port;

if (portNumber) {
  hostNameWithPort = `${hostNameNoWWW}:${portNumber}`;
}
const hostNameWithHTTP = window.location.protocol + "//" + hostNameWithPort;
export { hostNameWithHTTP, hostNameNoWWW };
const baseUrl_SPB=`https://api.${hostNameNoWWW}`;
export { baseUrl_SPB };
const baseUrl_PB=`https://py.${hostNameNoWWW}/`;

export { baseUrl_PB };
